import axios from 'axios';
import { emptyArray } from 'ui-components/default-props/empty';
import { createCancelablePromise } from '../../../services/promises/create-cancelable-promise';
import { LogService } from '../../../services/log-service';

const SERVICE_COLLECTIONS_PREFIX = 'serviceCollection';

const handleServiceCollectionError = (err) => {
  const jsonError = err?.toJSON() || err;
  const { config, statusText, data, status = 'unknown', message = 'Error fetching service collections', stack } = jsonError || {};
  LogService.logInfo(message, {
    config,
    statusText,
    status,
    stack,
    data,
  });
};

export const getSellerServiceCollections = async () => {
  try {
    const response = await axios.get(SERVICE_COLLECTIONS_PREFIX);
    return response?.data ?? emptyArray;
  } catch (err) {
    handleServiceCollectionError(err);
    return emptyArray;
  }
};
export const getSellerServiceCollectionsCancelablePromise = () =>
  createCancelablePromise(axios.get(SERVICE_COLLECTIONS_PREFIX)).promise.catch((err) => {
    handleServiceCollectionError(err);
    return emptyArray;
  });

export const upsertServiceCollection = ({
  serviceCollectionGuid,
  name,
  services,
  isActive = true,
  maxTransitDays = null,
  useDeliverByDate = false,
  cheapestOverride = null,
  rerateOrders = false,
}) =>
  axios.post(SERVICE_COLLECTIONS_PREFIX, {
    serviceCollectionGuid,
    name,
    services,
    isActive,
    maxTransitDays,
    useDeliverByDate,
    cheapestOverride,
    rerateOrders,
  });

export const toggleRateShopper = async (serviceCollectionGuid, isActive) =>
  axios.post(`${SERVICE_COLLECTIONS_PREFIX}/active-status`, {
    serviceCollectionGuid,
    isActive,
  });

export const deleteServiceCollection = async (serviceCollectionGuid) => {
  await axios.delete(`${SERVICE_COLLECTIONS_PREFIX}/${serviceCollectionGuid}`);
};

export const getCostReview = (fulfillmentPlanId) => {
  return axios.get(`${SERVICE_COLLECTIONS_PREFIX}/cost-review/${fulfillmentPlanId}`);
};
